import classNames from 'classnames';

import { ButtonIconProps } from './button.types';
import {
  BUTTON_VARIANT_CLEAN,
  BUTTON_VARIANT_FILL,
  BUTTON_VARIANT_M,
  BUTTON_VARIANT_OUTLINE,
  BUTTON_VARIANT_S,
} from './config';

export const ButtonIcon = ({
  as: Component = 'button',
  disabled,
  variant = BUTTON_VARIANT_FILL,
  size = BUTTON_VARIANT_S,
  rounded = false,
  Icon,
  iconClassName,
  className,
  ...props
}: ButtonIconProps) => {
  return (
    <Component
      disabled={Component === 'button' ? disabled : undefined}
      {...props}
      className={classNames(className, rounded ? 'rounded-full' : 'rounded-sm', {
        flex: Component === 'div',
        'text-primary border border-hard hover:border-medium focus:border-medium':
          variant === BUTTON_VARIANT_OUTLINE && !disabled,
        'text-tertiary border border-extra-soft cursor-not-allowed': variant === BUTTON_VARIANT_OUTLINE && disabled,
        'text-primary hover:fill-tertiary active:fill-tertiary-active focus-visible:fill-tertiary-active':
          variant === BUTTON_VARIANT_CLEAN && !disabled,
        'text-tertiary cursor-not-allowed': variant === BUTTON_VARIANT_CLEAN && disabled,
        'text-primary fill-tertiary active:fill-tertiary-active focus-visible:fill-tertiary-active cursor-pointer':
          variant === BUTTON_VARIANT_FILL && !disabled,
        'text-tertiary bg-tertiary cursor-not-allowed': variant === BUTTON_VARIANT_FILL && disabled,
        'p-2': size === BUTTON_VARIANT_S,
        'p-3': size === BUTTON_VARIANT_M,
      })}>
      <Icon className={classNames('w-5 h-5', iconClassName)} />
    </Component>
  );
};
